import {RestVialItem, Batch} from '@cypro/engine/schema'
import {Box, Text, Badge, IconButton} from '@chakra-ui/react'
import {getNumberFormatter, getShortDateFormatter} from '@cypro/ui/utils'
import {DisplayInput} from '@cypro/ui/components/form/display-input'
import {useTranslate} from '@tolgee/react'
import {LuTrash2} from 'react-icons/lu'

interface RestVialRowProps {
  restVial: RestVialItem
  batches: Batch[]
  onRemove?: () => void
}

export function RestVialRow({restVial, batches, onRemove}: RestVialRowProps) {
  const {t} = useTranslate('common')
  const batch = batches.find(b => b.id === restVial.batchId)
  const expiryDate = restVial.expiryDate ? getShortDateFormatter().format(new Date(restVial.expiryDate)) : '-'
  const batchName = batch?.tradeName?.name || batch?.consumable?.name || 'Batch name'

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Box display="flex" flexDirection="row" gap="2" alignItems="center" paddingInline="2" paddingBlock="1.5">
        <Box maxWidth="75px" display="flex" flexDirection="row" alignItems="center">
          <DisplayInput label={''} value={'1'} />
        </Box>
        <Box display="flex" flexDirection="column" justifyContent="center" flex="1">
          <Box display="flex" flexDirection="row" gap="1" alignItems="center">
            <Text fontSize="sm" fontWeight="medium">
              {batchName} ({getNumberFormatter().format(Number(restVial.amount ?? 0))} {restVial.strengthUnit})
            </Text>
            <Badge colorPalette="orange" size="sm" flexShrink={0}>
              {t('rest_vial')}
            </Badge>
          </Box>
          <Text fontSize="12px" fontWeight="normal" color="fg.muted">
            {t('batch_decription', {
              quantity: 1,
              lotNumber: batch?.lotNumber,
              expiryDate: expiryDate ? expiryDate : '-',
            })}
          </Text>
        </Box>
        <IconButton size="sm" variant="ghost" color="fg.error" title={t('delete')} onClick={onRemove}>
          <LuTrash2 />
        </IconButton>
      </Box>
    </Box>
  )
}
